import { PencilSquareIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

export default function ProductTableAction({ onEdit, onOpen, editLabel = "Editar", openLabel = "Ver detalle" }) {
    return (
        <div className="tw-flex tw-items-center tw-justify-end tw-gap-2">
        {onEdit ? (
            <button
            type="button"
            onClick={(event) => {
                event.stopPropagation();
                onEdit();
            }}
            className="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-600 tw-transition hover:tw-bg-slate-100 hover:tw-text-slate-900"
            aria-label={editLabel}
            >
            <PencilSquareIcon className="tw-h-4 tw-w-4" />
            </button>
        ) : null}

        {onOpen ? (
            <button
            type="button"
            onClick={(event) => {
                event.stopPropagation();
                onOpen();
            }}
            className="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-cyan-700 tw-transition hover:tw-bg-cyan-50"
            aria-label={openLabel}
            >
            <ChevronRightIcon className="tw-h-4 tw-w-4" />
            </button>
        ) : null}
        </div>
    );
}